<template>
  <div class="container">
    <ValidationObserver v-slot="{handleSubmit}">
      <form
        id="form"
        @submit.prevent="handleSubmit(onSubmit)"
      >
        <ValidationProvider
          :name="$t('modal.form.driver.label')"
          roles="required"
          v-slot="{ errors }"
        >
          <label>
            {{$t('modal.form.driver.label')}}
            <v-select
              v-model="form.driver_id"
              :options="driverOptions"
              @input="checkDriverRound"
            ></v-select>

            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>


        <ValidationProvider
          :name="$t('modal.form.product.label')"
          roles="required"
          v-slot="{errors}"
        >
          <label>
            {{$t('modal.form.product.label')}}
            <v-select
              v-model="form.product_id"
              :options="productsOptions"
            ></v-select>
            <span class="text-danger">{{errors[0]}}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.quantity.label')"
          roles="required|min:1"
          v-slot="{errors}"
        >
          <label>
            {{$t('modal.form.quantity.label')}}
            <input
              type="number"
              max="50"
              min="1"
              v-model="form.quantity"
              :placeholder="$t('modal.form.quantity.label')"
            >
            <span class="text-danger">{{errors[0]}}</span>
          </label>
        </ValidationProvider>
        <div v-if="openRounds.length > 0" class="text-danger">
          Yopilmagan reys mavjud:
        </div>
        <div v-for="(round, index) in openRounds" :key="index">
          {{round.created_at | filterDate}}
        </div>
        <div class="d-flex justify-content-end mt-3">
          <b-button
            variant="warning"
            @click="onClose"
          >
            {{$t('modal.button.back')}}
          </b-button>

          <b-button
            class="ms-3"
            variant="success"
            type="submit"
            form="form"
            :disabled="db || openRounds.length > 0"
          >
            {{$t('modal.button.post')}}
          </b-button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import {
  checkIfDriverHasOpenRound,
  showManagerWaterRound,
  storeManagerWaterRound,
  updateManagerWaterRound
} from '../../../../api/endpoints/managerWaterRound'
import moment from "moment";

  export default {
    name: "ManagerWaterRound-ActionModal",
    props: {
      driverOptions: {
        type: Array,
        required: true
      },
      productsOptions: {
        type: Array,
        required: true
      },
      id: {
      }
    },
    filters: {
      filterDate(val) {
        return moment(val).format('DD.MM.YYYY')
      }
    },
    data() {
      return {
        form: {
          driver_id: null,
          product_id: null,
          quantity: null,
        },
        actionPost: false,
        db: false,
        openRounds: [],
      }
    },
    methods: {
      rejectArray(index) {
        this.form.products.splice(index, 1)
      },
      addObject() {
        this.form.products.push({product_id: null, quantity: null,})
      },
      onClose() {
        this.$emit('onClose')
      },
      onSubmit() {
        this.db = true;
        setTimeout(() => {
          this.db = false;
        }, 700)
        if(this.actionPost) {
          storeManagerWaterRound({
            driver_id: this.form.driver_id.value,
            products: [
              {
                product_id: this.form.product_id.value,
                quantity: this.form.quantity,
              }
            ]
          })
            .then( () => {
              this.onClose();
            })
        } else {
          updateManagerWaterRound({
            id: this.id,
            driver_id: this.form.driver_id.value,
            products: [
              {
                product_id: this.form.product_id.value,
                quantity: this.form.quantity,
              }
            ]
          })
            .then( () => {
              this.onClose();
            })
        }
      },
      checkDriverRound() {
        checkIfDriverHasOpenRound(this.form.driver_id.value).then(res => {
          this.openRounds = res.data.data;
        })
      }
    },
    watch: {
      id: {
        immediate: true,
        handler(val) {
          if(val) {
            showManagerWaterRound(this.id).then( response => {
              let res = response.data.data;
              this.form = res;
              this.form.driver_id = {value: res.driver.id, label: res.driver.full_name}
              this.form.quantity = res.products[0].pivot.quantity
              this.form.product_id = {value: res.products[0].id, label: res.products[0].name}
            })
          } else {
            this.actionPost = true
          }
        }
      },
      productsOptions: {
        immediate: true,
        handler(val) {
          this.form.product_id = val[0]
        }
      }
    }

  }

</script>
